import { LeanIcon } from "./LeanIcon";
import styles from "./LeanPaginator.module.scss";

export interface ILeanPaginatorProps {
  pageSize: number;
  length: number;
  currentPage: number;
  setCurrentPage: (currentPage: number) => void;
}

type Slot =
  | {
      type: "current" | "link";
      page: number;
    }
  | {
      type: "dots";
    };

export const LeanPaginator: React.FC<ILeanPaginatorProps> = ({ pageSize, length, currentPage, setCurrentPage }) => {
  if (pageSize < 1) {
    pageSize = 1;
  }

  if (length < 1) {
    length = 1;
  }

  if (currentPage < 0) {
    currentPage = 0;
  }

  const pageCount = Math.floor((length + pageSize - 1) / pageSize);

  if (currentPage >= pageCount) {
    currentPage = pageCount - 1;
  }

  const slots: Slot[] = [];

  if (pageCount <= 7) {
    for (let i = 0; i < pageCount; i++) {
      slots.push({ page: i, type: i === currentPage ? "current" : "link" });
    }
  } else {
    // display the first 5 slots, then ..., then the last page
    if (currentPage <= 3) {
      for (let i = 0; i <= 4; i++) {
        if (i === currentPage) {
          slots.push({ page: currentPage, type: "current" });
        } else {
          slots.push({ page: i, type: "link" });
        }
      }
      slots.push({ type: "dots" });
      slots.push({ page: pageCount - 1, type: "link" });
    } else if (currentPage >= pageCount - 4) {
      // display the first page, then ..., then the last 5 slots
      slots.push({ type: "link", page: 0 });
      slots.push({ type: "dots" });
      for (let i = pageCount - 5; i < pageCount; i++) {
        if (i === currentPage) {
          slots.push({ page: currentPage, type: "current" });
        } else {
          slots.push({ page: i, type: "link" });
        }
      }
    } else {
      // display the first page, then ..., then 3 slots, then ..., then the last page
      slots.push({ type: "link", page: 0 });
      slots.push({ type: "dots" });
      slots.push({ page: currentPage - 1, type: "link" });
      slots.push({ page: currentPage, type: "current" });
      slots.push({ page: currentPage + 1, type: "link" });
      slots.push({ type: "dots" });
      slots.push({ page: pageCount - 1, type: "link" });
    }
  }

  return (
    <ul className={styles.paginator}>
      <li
        className={currentPage === 0 ? styles.disabled : ""}
        onClick={currentPage > 0 ? () => setCurrentPage(currentPage - 1) : undefined}
      >
        <button>
          <LeanIcon icon={"ChevronLeft"} size={"14px"} />
        </button>
      </li>
      {slots.map((slot, index) =>
        slot.type === "dots" ? (
          <li key={index}>
            <button>...</button>
          </li>
        ) : slot.type === "current" ? (
          <li key={index} className={styles.current}>
            <button>{slot.page + 1}</button>
          </li>
        ) : (
          <li key={index} onClick={() => setCurrentPage(slot.page)}>
            <button>{slot.page + 1}</button>
          </li>
        )
      )}
      <li
        className={currentPage === pageCount - 1 ? styles.disabled : ""}
        onClick={currentPage < pageCount - 1 ? () => setCurrentPage(currentPage + 1) : undefined}
      >
        <button>
          <LeanIcon icon={"ChevronRight"} size={"14px"} />
        </button>
      </li>
    </ul>
  );
};
